import { Routine } from 'redux-saga-routines';
import { ICandidate } from '../../../../common/models/candidate/ICandidate';
import {
  fetchCandidatesRoutine,
  fetchCandidateCountersRoutine,
  updateCandidateFilterRoutine
} from '../../routines';
import { CandidateCounts } from '../../../../common/models/candidate/CandidateCounts';
import { createReqRefRoutine } from '../../../RequestBuilder/routines';
import {
  updateCandidateOwnerRoutine,
  updateCandidateStatusRoutine
} from '../../../../containers/CandidatesBulkActions/routines';
import {
  changeCandidatePositionRoutine,
  saveContactInfoRoutine,
  updateRefStatusRoutine
} from '../../../ContactProfile/routines';
import { mergeContactsRoutine } from '../../../../containers/MergeContacts/routines';
import { IFilter } from '../../../../common/models/filter/IFilter';
import { AssignmentFilterType } from '../../../../common/enums/AssignmentFilterType';

export type CandidateState = {
  counters: CandidateCounts;
  candidates: ICandidate[];
  total: number;
  loading: boolean;
  assignmentFilter: AssignmentFilterType;
  filter?: IFilter;
};

const initialCounters = {
  AllActive: 0,
  WaitingForCandidate: 0,
  NoSurveysComplete: 0,
  OnePlusSurveysComplete: 0,
  AllSurveysComplete: 0,
  AllInactive: 0,
  InactiveHired: 0,
  InactiveHibernate: 0
};

const initialState: CandidateState = {
  counters: initialCounters,
  candidates: [],
  total: 0,
  filter: undefined,
  assignmentFilter: AssignmentFilterType.Me,
  loading: false
};

export const candidates = (state: CandidateState = initialState, { type, payload }: Routine<any>) => {
  switch (type) {
    case fetchCandidatesRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case fetchCandidatesRoutine.SUCCESS:
      const items = payload.reset ? payload.items : [...state.candidates, ...payload.items];
      return {
        ...state,
        counters: state.counters,
        candidates: items,
        total: payload.total,
        loading: false
      };
    case fetchCandidateCountersRoutine.SUCCESS:
      return {
        ...state,
        counters: payload
      };
    case updateCandidateStatusRoutine.SUCCESS:
    case createReqRefRoutine.SUCCESS:
    case updateCandidateOwnerRoutine.SUCCESS:
    case changeCandidatePositionRoutine.SUCCESS:
    case saveContactInfoRoutine.SUCCESS:
    case mergeContactsRoutine.SUCCESS:
    case updateRefStatusRoutine.SUCCESS:
      return {
        ...state,
        counters: state.filter ? undefined : state.counters
      };
    case fetchCandidatesRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    case updateCandidateFilterRoutine.TRIGGER: {
      const { filter, assignmentFilter } = payload;
      return {
        ...state,
        filter,
        assignmentFilter: assignmentFilter || state.assignmentFilter
      };
    }
    default:
      return state;
  }
};
